import useSWR, { mutate } from "swr";
import { useSudowriteStore } from "../stores/sudowriteStore";
import {
  INSTALLATIONS_LIST_KEY,
  INSTALLATIONS_LIST_SWR_OPTIONS,
  createInstalledPluginsFetcher,
} from "./installedPluginsListCache";

export default function useInstalledPlugins() {
  const cachedInstalledPlugins = useSudowriteStore((state) => state.installedPlugins);
  const setInstalledPlugins = useSudowriteStore((state) => state.setInstalledPlugins);

  const fetcher = createInstalledPluginsFetcher({
    requestSource: "installed-plugins-swr",
    onFetched: setInstalledPlugins,
  });

  const { data, error, isLoading } = useSWR(INSTALLATIONS_LIST_KEY, fetcher, INSTALLATIONS_LIST_SWR_OPTIONS);

  // Keep plugin-dependent controls usable when SWR is between retries or a
  // transient body-read failure happens after a prior fetch already worked.
  const installedPlugins = data || cachedInstalledPlugins || [];

  const refetchInstallations = async () => {
    await mutate(INSTALLATIONS_LIST_KEY);
  };

  return { installedPlugins, refetchInstallations, isLoading, error };
}
